import { render, staticRenderFns } from "./PersonalProject.vue?vue&type=template&id=2de6514a&scoped=true"
import script from "./PersonalProject.vue?vue&type=script&lang=js"
export * from "./PersonalProject.vue?vue&type=script&lang=js"
import style0 from "./PersonalProject.vue?vue&type=style&index=0&id=2de6514a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de6514a",
  null
  
)

export default component.exports